import {
  createInstrumentsCategory,
  getInstrumentsCategory,
  updateCInstrumentsCategory,
  deleteCategory,

  createInstrumentsModel,
  getInstrumentsModel,
  updateCInstrumentModel,
  deleteInstruments,

  createInstrumentsModelVariant,
  getInstrumentsModelVarian,
  getInstrumentRemains,
  updateCInstrumentModelVarian,
  deleteInstrumentsVarian,
  createWriteOffForInstrument,
  updateWriteOffForInstrument,
  getInstrumentModalDetails,
  getInstrumentRemainsBuilders,
  exportExcelInstruments,
  exportExcelInstrumentTypes,
} from '@/api/reference'

export default {
  CREATE_INSTRUMENTS_CATEGORY(_, data) {
    return createInstrumentsCategory(data)
  },

  FETCH_INSTRUMENTS_CATEGORY({ commit }, params) {
    return getInstrumentsCategory(params)
      .then(res => {
        commit('SET_INSTRUMENT_CATEGORIES', res.data)
      })
  },

  FETCH_INSTRUMENTS_REMAINS_BUILDERS({ commit }, params) {
    return getInstrumentRemainsBuilders(params)
      .then(res => {
        commit('SET_INSTRUMENTS_REMAINS_BUILDERS', res.data)
      })
  },

  UPDATE_INSTRUMENTS_CATEGORY(_, data) {
    return updateCInstrumentsCategory(data)
  },

  DELETE_INSTRUMENTS_CATEGORY(_, id) {
    return deleteCategory(id)
  },
  /// model

  CREATE_INSTRUMENTS_MODEL(_, data) {
    return createInstrumentsModel(data)
  },

  FETCH_INSTRUMENTS_MODEL({ commit }, params) {
    return getInstrumentsModel(params)
      .then(res => {
        commit('SET_CHARACTER_MODEL', res.data)
      })
  },

  FETCH_INSTRUMENTS_MODAL_DETAILS({ commit }, id) {
    return getInstrumentModalDetails(id)
      .then(res => {
        commit('SET_INSTRUMENTS_MODAL_DETAILS', res.data)
      })
  },

  UPDATE_INSTRUMENTS_MODEL(_, data) {
    return updateCInstrumentModel(data)
  },

  DELETE_INSTRUMENTS_MODEL(_, id) {
    return deleteInstruments(id)
  },

  // instrumentModel

  CREATE_INSTRUMENTS_MODEL_VARIANT(_, data) {
    return createInstrumentsModelVariant(data)
  },

  FETCH_INSTRUMENTS_MODEL_VARIANT({ commit }, params) {
    return getInstrumentsModelVarian(params)
      .then(res => {
        commit('SET_CHARACTER_MODEL_VARIANT', res.data)
      })
  },
  FETCH_INSTRUMENT_REMAINS({ commit }, params) {
    return getInstrumentRemains(params)
      .then(res => {
        commit('SET_INSTRUMENT_REMAINS', res.data)
      })
  },

  FETCH_INSTRUMENTS_FOR_ENTERING({ commit }, params) {
    return getInstrumentsModelVarian(params)
      .then(res => {
        commit('SET_INSTRUMENTS_FOR_ENTERING', res.data)
      })
  },

  UPDATE_INSTRUMENTS_MODEL_VARIANT(_, data) {
    return updateCInstrumentModelVarian(data)
  },

  DELETE_INSTRUMENTS_MODEL_VARIANT(_, id) {
    return deleteInstrumentsVarian(id)
  },
  CREATE_WRITE_OFF_FOR_INSTRUMENT(_, data) {
    return createWriteOffForInstrument(data)
  },


  UPDATE_WRITE_OFF_FOR_INSTRUMENT(_, data) {
    return updateWriteOffForInstrument(data)
  },

  EXPORT_EXCEL_INSTRUMENT_TYPES(_, params) {
    return exportExcelInstrumentTypes(params);
  },
  EXPORT_EXCEL_INSTRUMENTS(_, params) {
    return exportExcelInstruments(params);
  },
}
